import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HeatmapType } from '../../../../shared/enums/heatmapType.enum';
import { TimePeriod } from '../../../../shared/enums/timePeriods.enum';
import initialLoadEfficiencySliceState from './loadEfficiency-initial-state';
import { WorkingEfficiency } from '../models/efficiency.model';

const loadEfficiencySlice = createSlice({
    name: 'loadEfficiencySlice',
    initialState: initialLoadEfficiencySliceState,
    reducers: {
        setLoadEfficiency(state, { payload }: PayloadAction<WorkingEfficiency | null>) {
            state.loadEfficiency = payload;
        },
        setOrganizations(state, { payload }: PayloadAction<string[]>) {
            state.organizations = payload;
        },
        setCompanies(state, { payload }: PayloadAction<string[]>) {
            state.companies = payload;
        },
        setDepartments(state, { payload }: PayloadAction<string[]>) {
            state.departments = payload;
        },
        setForklfts(state, { payload }: PayloadAction<string[]>) {
            state.forklits = payload;
        },
        setTags(state, { payload }: PayloadAction<string[]>) {
            state.tags = payload;
        },
        setModels(state, { payload }: PayloadAction<string[]>) {
            state.models = payload;
        },
        setActivities(state, { payload }: PayloadAction<string[]>) {
            state.activities = payload;
        },
        setCreateDate(state, { payload }: PayloadAction<string>) {
            state.dates.startDate = payload;
        },
        setEndDate(state, { payload }: PayloadAction<string>) {
            state.dates.endDate = payload;
        },
        setPeriod(state, { payload }: PayloadAction<TimePeriod>) {
            state.period = payload;
        },
        setHeatmapType(state, { payload }: PayloadAction<HeatmapType>) {
            state.heatmapType = payload;
        },
        setShowFilters(state, { payload }: PayloadAction<boolean>) {
            state.showFilters = payload;
        },
        setShifts(state, { payload }: PayloadAction<any[]>) {
            state.shifts = payload;
        },
        setWeeklyWorkingHours(state, { payload }: PayloadAction<number>) {
            state.weeklyWorkingHours = payload;
        },
        setMonthlyWorkingHours(state, { payload }: PayloadAction<number>) {
            state.monthlyWorkingHours = payload;
        }
    }
});

export const {
    setLoadEfficiency,
    setOrganizations,
    setCompanies,
    setForklfts,
    setTags,
    setModels,
    setActivities,
    setCreateDate,
    setEndDate,
    setPeriod,
    setHeatmapType,
    setDepartments,
    setShowFilters,
    setShifts,
    setWeeklyWorkingHours,
    setMonthlyWorkingHours
} = loadEfficiencySlice.actions

export default loadEfficiencySlice.reducer
